import React from "react";

import styled from "styled-components/macro";

// import FnrProgressBar from "UI/FnrProgressBar";
import FnrProgressBar from "UI/FnrProgressBar2";

export default function ItemResults({
  count,
  max,
  delay = 0,
  entitySingle,
  entityPlural,
  signupListTypeID,
  signupItems,
  hideProgressBar = false,
}) {
  const signupItemsCopy = signupItems?.length
    ? JSON.parse(JSON.stringify(signupItems))
    : [];

  const isPollType = signupListTypeID === 4;

  const getAvailable = () => {
    if (isPollType) {
      return (
        <div className="available">
          {count} {String(count) === "1" ? "vote" : "votes"}
        </div>
      );
    } else {
      return (
        <div className="available">
          {max - count} {max - count === 1 ? entitySingle : entityPlural}{" "}
          available
        </div>
      );
    }
  };

  const getMaxToDisplay = () => {
    if (isPollType) return null;
    return <div className="total">{max}</div>;
  };

  const getMax = () => {
    if (isPollType) {
      return signupItemsCopy.sort((a, b) =>
        a.slotsTaken < b.slotsTaken ? 1 : -1
      )[0].slotsTaken;
    } else {
      return Number(max);
    }
  };

  return (
    <Wrapper>
      <ResultNumbers>
        {getAvailable()}
        {getMaxToDisplay()}
      </ResultNumbers>

      {hideProgressBar ? (
        <ProgressBarHidden />
      ) : (
        <FnrProgressBar count={Number(count)} max={getMax()} delay={delay} />
      )}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  position: relative;
  padding-bottom: 12px;
  margin-top: 12px;
`;

const ResultNumbers = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 3px;
`;

const ProgressBarHidden = styled.div`
  margin-top: -10px;
`;
